Time.$inject = ['_', 'moment'];

/* @ngInject */
function Time(_, moment) {
    // Shift value
    var SHIFT_HOURS = 6;

    // 
    this.moment = moment;
    this.Hour = Hour;
    this.today = today;
    this.durationToEnd = durationToEnd;
    this.durationToString = durationToString;
    this.rangeToArray = rangeToArray;
    this.floatToID = floatToID;
    this.momentToDay = momentToDay;
    this.isSame = isSame;
    this.date = date;
    this.now = now;
    this.diff = diff;

    ////////////////

    function today() {
        return moment().subtract(SHIFT_HOURS, 'hours');
    }

    /**
     * Calculates the end hour from the start hour and the duration minutes
     * @method durationToEnd
     * @param  {string} start Start hour in string format '15:30'
     * @param  {number} duration
     * @return {Hour}
     */
    function durationToEnd(start, duration) {
        var hour = new Hour();
        if (!start.hasOwnProperty('hour')) {
            if (_.isString(start)) {
                hour.fromString(start);
            } else {
                hour.fromFloat(start);
            }
        } else {
            hour.fromHour(start);
        }

        var hours = hour.getHour(),
            mins = hour.getMin(),
            tot = mins + parseInt(duration);

        mins = tot % 60;
        hours += Math.floor(tot / 60);

        hour.set(hours, mins);
        return hour;
    }

    /**
     * Duration integer to formatted string '1 hora y media'
     * @method durationToString
     * @param  {integer} duration
     * @return {string}
     */
    function durationToString(duration) {
        var hour = Math.floor(duration / 60),
            mins = duration % 60;

        var out = '';
        if (hour) {
            out += moment.duration(hour, 'hours').humanize();
            if (mins) {
                out += ' y ';
            }
        }
        if (mins) {
            out += moment.localeData().relativeTime(mins, false, 'mm', '');
        }

        return out;
    }

    /**
     * Taking a start and end date, returns an array of every in-between date
     * @method rangeToArray
     * @param  {Object} range
     * @param  {moment} range.start
     * @param  {moment} range.end
     * @param  {Boolean} includeLast
     * @return {array} Array of moment dates
     */
    function rangeToArray(range, includeLast) {
        var start = moment(range.start);
        var arr = [];
        var method = includeLast ? 'isSameOrBefore' : 'isBefore';
        for (var cursor = start.clone(); cursor[method](range.end, 'day'); cursor.add(1, 'day')) {
            arr.push(cursor.clone());
        }
        return arr;
    }

    /**
     * Creates a hour #id like string
     * @method floatToID
     * @param  {float} float
     * @return {string} id
     */
    function floatToID(float) {
        return float.toFixed(5).replace('.', '-');
    }

    /**
     * Shifts the hours and returns the day of the week
     * @method momentToDay
     * @param  {moment} date
     * @return {Number}
     */
    function momentToDay(date) {
        return date.clone()
            .subtract(SHIFT_HOURS, 'hours')
            .day();
    }

    /**
     * Shifts the target and compares them using moment(current).isSame(target, option)
     * @method isSame
     * @param  {moment} current
     * @param  {moment} target
     * @param  {string} option
     * @return {Boolean}
     */
    function isSame(current, target, option) {
        var _target = moment(target).subtract(SHIFT_HOURS, 'hours');
        return moment(current).isSame(_target, option);
    }

    /**
     * Returns a shifted moment hour based on the input. If null, use now
     * @method date
     * @param  {any} d
     * @return {moment}
     */
    function date(d) {
        return moment(d).subtract(SHIFT_HOURS, 'hours');
    }

    /**
     * Returns the current timestamp in seconds
     * @method now
     * @param  {Boolean} ms If you want the time in miliseconds
     * @return {Integer}
     */
    function now(ms) {
        if (ms) {
            return Date.now();
        }
        return (Date.now() / 1000).toFixed(1);
    }

    /**
     * Takes the end time and calculates the diff in seconds
     * @method diff
     * @param  {Integer} start Timestamp start
     * @param  {Boolean} ms If you use miliseconds
     * @return {Integer}
     */
    function diff(start, ms) {
        var end = now(ms);
        return (end - start).toFixed(1);
    }

    /**
     * Hour class
     * @class Hour
     * @param  {Number} hour
     * @param  {Number} min
     */
    function Hour(hour, min) {
        hour = parseInt(hour);
        min = parseInt(min);

        this.set(hour, min);
    }

    /**
     * Takes a string/moment full date
     * @method fromMoment
     * @param  {moment|string} date
     * @chainable
     */
    Hour.prototype.fromMoment = function (date) {
        var m = moment(date);

        this.set(m.hour(), m.minute());
        return this;
    };

    /**
     * Takes a string hour '14:30' format
     * @method fromString
     * @param  {string} string
     * @chainable
     */
    Hour.prototype.fromString = function (string) {
        var time = string.split(':');
        this.hour = parseInt(time[0]);
        this.min = parseInt(time[1]);
        return this;
    };

    /**
     * Takes a float format (float part are minutes) 14.5
     * @method fromFloat
     * @param  {float} float
     * @chainable
     */
    Hour.prototype.fromFloat = function (float) {
        var hour = Math.floor(float);
        var min = 0;

        var decimal = float % 1;
        if (decimal !== 0) {
            min = Math.round(60 * decimal);
        }
        if (min === 60) {
            hour += 1;
            min = 0;
        }

        this.set(hour, min);
        return this;
    };

    /**
     * From a js Date
     * @method fromDate
     * @param  {Date} date
     * @chainable
     */
    Hour.prototype.fromDate = function (date) {
        this.hour = date.getHours();
        this.min = date.getMinutes();
        return this;
    };

    /**
     * From another Hour
     * @method fromHour
     * @param  {Hour} hour
     * @chainable
     */
    Hour.prototype.fromHour = function (hour) {
        this.hour = hour.hour;
        this.min = hour.min;
        return this;
    };

    /**
     * @method getMin
     * @return {Number} integer
     */
    Hour.prototype.getMin = function () {
        return parseInt(this.min);
    };
    /**
     * @method getHour
     * @return {Number} integer
     */
    Hour.prototype.getHour = function () {
        return parseInt(this.hour);
    };

    /**
     * @method set
     * @param  {Number} hour
     * @param  {Number} min
     * @chainable
     */
    Hour.prototype.set = function (hour, min) {
        if (_.isNumber(hour)) {
            this.hour = (hour < SHIFT_HOURS) ? hour + 24 : hour;
        }
        if (_.isNumber(min)) {
            this.min = min;
        }
        return this;
    };

    /**
     * Subtract two hours and return the hours diff in float
     * @method subtract
     * @param  {Hour} date
     * @return {float}
     */
    Hour.prototype.subtract = function (date) {
        var res = new Hour();
        res.hour = this.hour - date.hour;
        res.min = this.min - date.min;

        return res.toSimpleFloat();
    };

    Hour.prototype.addMinutes = function (int) {
        var hour = Math.floor(int / 60);
        var min = int % 60;

        this.hour += hour;
        this.min += min;
        return this;
    };

    /**
     * Greater than
     * @method gt
     * @param  {Hour} date
     * @return {Boolean}
     */
    Hour.prototype.gt = function (date) {
        return this.toFloat() > date.toFloat();
    };

    /**
     * @method toString
     * @return {String}
     */
    Hour.prototype.toString = function () {
        return ('0' + this.hour).substr(-2) + ':' + ('0' + this.min).substr(-2);
    };

    /**
     * To string 24hs range
     * @method toStringFormalized
     * @return {String}
     */
    Hour.prototype.toStringFormalized = function () {
        return ('0' + (this.hour % 24)).substr(-2) + ':' + ('0' + this.min).substr(-2);
    };

    /**
     * @method toDate
     * @return {Date}
     */
    Hour.prototype.toDate = function () {
        var d = new Date();
        d.setHours(this.hour);
        d.setMinutes(this.min);
        return d;
    };

    /**
     * @method toMoment
     * @param  {Date | moment} base The date to set the hours & minutes [default=now]
     * @return {moment}
     */
    Hour.prototype.toMoment = function (base) {
        var d = base ? moment(base) : moment();

        if (this.hour > 24) {
            d.add('day');
            d.hour(this.hour - 24);
        } else {
            d.hour(this.hour);
        }

        d.minutes(this.min);

        return d;
    };


    /**
     * @method toFloat
     * @return {float}
     */
    Hour.prototype.toFloat = function () {
        var hour = (this.hour < SHIFT_HOURS) ? (24 + this.hour) : this.hour;
        var minutes = parseInt(this.min * (10 / 6));
        return hour + minutes / 100;
    };
    /**
     * To float without the shifted hours
     * @method toSimpleFloat
     * @return {float}
     */
    Hour.prototype.toSimpleFloat = function () {
        var hour = this.hour;
        var minutes = parseInt(this.min * (10 / 6));
        return hour + minutes / 100;
    };

    /**
     * @method toMinutes
     * @return {int}
     */
    Hour.prototype.toMinutes = function () {
        return this.hour * 60 + this.min;
    };

    /**
     * @method clone
     * @return {Hour}
     */
    Hour.prototype.clone = function () {
        return new Hour(this.hour, this.min);
    };
}

export default Time;
